import * as AF from "@/components/form-items/AbstractForm";
import { useAuth } from "@/context/auth/AuthContext";
import useMediaAttachment from "@/hooks/useMediaAttachment";
import { SupportedLocale } from "@/i18n";
import { generateImageName } from "@/lib/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CroppedImageInput } from "../form-fields/CroppedImageInput";

interface ContactFormProps {
  language: SupportedLocale;
}

export const ContactForm = ({ language }: ContactFormProps) => {
  const { t } = useTranslation();

  const imagePosition = useMemo(
    () => `contactImage${language.toLocaleUpperCase()}`,
    [language],
  );

  const { instanceData } = useAuth();

  const { attachment, previewImageUrl, refetch } = useMediaAttachment(
    imagePosition,
    instanceData?.id,
  );

  return (
    <AF.Col>
      <AF.Text
        name={`${language}.pageName`}
        label={t("cms.contact.form.pageName")}
        tootltip={t("cms.contact.form.pageName.tooltip")}
      />

      <AF.RichText
        name={`${language}.content`}
        label={t("cms.contact.form.content")}
      />
      {/* Formulaire contact masqué côté front — le mail destinataire n'est plus utile
      <AF.Text name={`${language}.email`} label={t("cms.contact.form.email")} />
      */}
      <CroppedImageInput
        docId={instanceData?.id}
        imageURL={previewImageUrl}
        attachment={attachment}
        refetch={refetch}
        imagePosition={imagePosition}
        aspect={0.78}
        label={t("contactImageLabel")}
        buildImageName={(instanceName) =>
          generateImageName({
            primaryType: "CMSPages",
            instanceName,
            translatedPageName: t("seo.imageName.contact"),
          })
        }
      />
      <AF.Text
        name={`${language}.credits`}
        label={t("cms.contact.form.credits")}
      />
    </AF.Col>
  );
};
